import { CustomAppUserApi } from "src/api/generated/erp/customApps/api/customAppUserApi.ts";
import type { CustomAppAvailableLauncher } from "src/api/generated/erp/customApps/runtime/customAppAvailableLauncher.ts";
import type { CustomFunctionUiActionContext } from "src/api/generated/erp/customFunctions/triggers/uiAction/context/customFunctionUiActionContext.ts";
import { toJsonObject } from "src/components/views/ai/assistant/uiContext/jsonValueUtils.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import { useOpenCustomAppFrameDialog } from "./useOpenCustomAppFrameDialog.tsx";

export function useOpenCustomAppDialog() {
	const openFrameDialog = useOpenCustomAppFrameDialog();
	return async (
		launcher: CustomAppAvailableLauncher,
		context: CustomFunctionUiActionContext,
		refresh?: () => Promise<unknown>,
	) => {
		const access = await CustomAppUserApi.createLauncherAccess({
			customAppId: launcher.customAppId,
			launcherKey: launcher.launcher.launcherKey,
			context,
		});
		openFrameDialog({
			access,
			customAppId: launcher.customAppId,
			dialogTitle: launcher.launcher.label,
			appName: launcher.appName,
			agentContext: {
				key: defineAgentUiContextKey("customApps.launch"),
				data: {
					customAppId: launcher.customAppId,
					customAppRevisionId: access.customAppRevisionId,
					launcherKey: launcher.launcher.launcherKey,
					input: toJsonObject(access.input),
				},
			},
			onClosed: refresh,
		});
	};
}
